// components/CandidatesSection.jsx
import React from 'react';
import styled from 'styled-components';

const Section = styled.section`
  padding: 120px 2rem;
  background: #000000;
  position: relative;
`;

const Container = styled.div`
  max-width: 1350px;
  margin: 0 auto;
  width: 100%;
`;

/* Left-aligned title – identical to ClientsSection */
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const Square = styled.div`
  width: 15px;
  height: 15px;
  background: #ffffff;
  flex-shrink: 0;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  color: #ffffff;
  margin: 0;
  font-weight: 500;
  white-space: nowrap;
`;

/* 3 columns, 2 rows */
const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled.div`
  background: #0b0b0bff;
  border: 1px solid #2a2a2a;
  padding: 3rem;
  min-height: 220px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  border-radius: 0;
  text-align: left;

  opacity: 0;
  transform: translateY(30px);
  animation: fadeUp 0.7s ease-out forwards;
  animation-delay: ${props => props.delay || '0s'};

  h3 {
    font-size: 1.5rem;
    color: #ffffff;
    margin: 0 0 1rem 0;
    font-weight: 700;
  }

  p {
    font-size: 1.1rem;
    color: #cbd5e1;
    line-height: 1.7;
    margin: 0;
  }

  @keyframes fadeUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 2.5rem 2rem;
    min-height: auto;
  }
`;

const CandidatesSection = () => {
  const services = [
    {
      title: 'We listen to you',
    },
    {
      title: 'We get to know your organization fully',
    },
    {
      title: 'We understand your company culture and specific job requirements',
    },
    {
      title: 'We ask the right questions',
    },
    {
      title: 'We build a lasting and trustworthy relationship',
    },
    {
      title: 'We find you the perfect candidate',
    },
  ];

  return (
    <Section id="candidates">
      <Container>
        <TitleRow>
          <Square />
          <SectionTitle>Candidates</SectionTitle>
        </TitleRow>

        <CardsGrid>
          {services.map((service, index) => (
            <ServiceCard key={index} delay={`${index * 0.1}s`}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </ServiceCard>
          ))}
        </CardsGrid>
      </Container>
    </Section>
  );
};

export default CandidatesSection;